<template>
  <v-container fluid>
      <v-tabs v-model="activeTab" centered>
        <v-tab>History</v-tab>
        <v-tab>Seasons</v-tab>
        <v-tab>Users</v-tab>
        <v-tab>Notifications</v-tab>
        <v-tab>Settings</v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab" touchless>
        <v-tab-item><History/></v-tab-item>
        <v-tab-item><Seasons/></v-tab-item>
        <v-tab-item><Users/></v-tab-item>
        <v-tab-item><Notifications/></v-tab-item>
        <v-tab-item><Settings/></v-tab-item>
      </v-tabs-items>
  </v-container>
</template>

<script>

import Notifications from "@/components/admin/Notifications";
import Seasons from "@/components/admin/Seasons";
import Settings from "../components/admin/Settings";
import History from "../components/admin/History";
import Users from "../components/admin/Users";

export default {
  name: 'Dashboard',
  components: {
    Notifications,
    Seasons,
    Users,
    History,
    Settings
  },
  data: () => ({
    activeTab: 0
  })
};
</script>

<style scoped>

</style>